module.exports = __webpack_public_path__ + "media/body-condition/puppy-chubby-0dfea1f6.svg";